export const defaultExplanatoryMsg = (graphType, varType) =>
  `To create a ${graphType}, select a ${varType} variable in Settings.`;

export const errMsgNoVarInDataset = (graphType, varType, varTypeCapitalized) =>
  `A ${graphType} cannot be created because a ${varType} variable has not been defined within the dataset. ${varTypeCapitalized} variables may be defined on the dataset page.`;

export const errMsgNeedAtLeastTwoVarsInDataset = (graphType, varType, varTypeCapitalized) =>
  `A ${graphType} cannot be created because two ${varType} variables have not been defined within the dataset. ${varTypeCapitalized} variables may be defined on the dataset page.`;

// scatter plot has unique messages
export const errMsgScatterPlot =
  'To create a Scatter Plot, select a pair of numerical variables in Settings.';

export const errMsgScatterPlotOneValue =
  'A Scatter Plot cannot be created because there\'s only one numerical variable defined within the dataset. Numeric variables may be defined on the dataset page.';

export const errMsgEmptyDataset = 'Your dataset is currently empty, please remove a few filters or select a new dataset before continuing.';

export const errMsgSecondTypeOfGraph = (graphType, varType) =>
  `To create a ${graphType}, select a ${varType} variable for the Grouping Variable in Settings.`;

export const errMsgFrequencyTable = graphType =>
  `A ${graphType} is not available for frequency or contingency tables. This graph requires a raw dataset.`;

export const graphTypes = {
  histogram: 'Histogram',
  dotPlot: 'Dot Plot',
  scatterPlot: 'Scatter Plot',
  barChart: 'Bar Chart',
  pieChart: 'Pie Chart',
  boxPlot: 'Box Plot',
  probabilityPlot: 'Probability Plot'
};
